import React = require('react');
import { filter, flow, get, head } from 'lodash';
import { Promise } from 'es6-promise';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { actions as authActions, IAuthActions } from '../../../../../../services/auth/reducer';
import { actions as headerActions } from '../../../../../../services/header/reducer';
import { push } from 'react-router-redux';
import { destroy, reset } from 'redux-form';
import { actions as quoteActions } from '../../../../../../services/quote/reducer';
import { mtaActions } from '../../../../../../services/mta/actions';
import { actions as brandingActions } from '../../../../../../services/branding/reducer';
import { paymentMethodActions } from '../../../../../../services/paymentMethod/actions';
import { IAuthState } from '../../../../../../services/auth/models';
import { withJob } from 'react-jobs';
import { useEffect, useState } from 'react';
import { IMtaActions, IMtaState } from '../../../../../../services/mta/models';
import Heap from '../../../../../../helpers/Heap';
import { canUpsellPolicy, resetForms } from '../MakeAChangeSelection/MTAHelpers';
import { IBrandingActions, IBrandingState } from '../../../../../../services/branding/models';
import { LoadingSpinner } from '../../../../../../components/LoadingSpinner';
import * as api from '../../../../../../data/api/api';
import { IPolicyClaims } from '../../../../../../data/api/models';

interface IAMTUpsellLandingProps {
  auth: IAuthState;
  mta: IMtaState;
  dispatch: any;
  branding: IBrandingState;
  actions: {
    auth: IAuthActions;
    push: (route: string) => Promise<void>;
    mta: IMtaActions;
    branding: IBrandingActions;
    reset(formName: string): void;
    destroy(formName: string): void;
  }
}

const AMTUpsellLanding = ({ auth, actions, mta, branding }: IAMTUpsellLandingProps) => {

  const [loading, setLoading] = useState(true);
  const promises = [];

  const setSelectedPolicy = (selectedPolicy: any, track = false): void => {
    if (selectedPolicy) {
      Promise.resolve(actions.mta.getPolicyInfo(selectedPolicy.id)).then(() => {
        const customerMTAOptions = get(branding.channel.products[0], 'metadata.direct_customer_mta_options', null);
        const canUpsell = canUpsellPolicy(selectedPolicy, mta, customerMTAOptions);
        Promise.resolve(actions.mta.setUpsellRules(canUpsell)).then(() => {
          if (track) {
            Heap.trackEvent('MtaJourneyStart', selectedPolicy, 'policy')
          }

          if (canUpsell) {
            Promise.resolve(actions.mta.setSelectedPolicy(selectedPolicy)).then(() => {
              resetForms(actions)
              setLoading(false);
              actions.push('/account/make-a-change/mta/customer-upsell')
            });
          } else {
            actions.push('/account/summary');
          }
        })
      });
      return;
    } else {
      actions.push('/account/summary');
    }
  }

  const checkActiveSTPolicy = () => {
    const activePolicies = get(auth, 'customer.activePolicies');
    const singleTripPolicies = filter(activePolicies, ['metadata.scheme_type', 'single']);
    const activeSTPolicy = head(singleTripPolicies)
    if ((singleTripPolicies && singleTripPolicies.length >= 2)) {
      actions.push('/account/summary');
    }

    promises.push(api.getCustomerRateableClaims())
    promises.push(actions.mta.setUpsellRules(false));
    Promise.all(promises).then((results) => {
      // Retrieve the claims from getCustomerRateableClaims.
      const claims = results[0]
      // Find any claims related to this policy
      const policyClaims = claims.filter((claim: IPolicyClaims) => claim?.attributes?.policy_id === activeSTPolicy?.id)

      policyClaims.forEach((claim: IPolicyClaims) => {
        // Open claims will prevent all MTA.
        if (get(claim, 'id', null) !== null && get(claim, 'attributes.claim_status') === 'open') {
          actions.push('/account/summary');
          return;
        }
      });

      setSelectedPolicy(activeSTPolicy, true);
    }).catch((error) => {
      actions.push('/account/summary');
    });
  }

  useEffect(() => {
    sessionStorage.setItem('showMarketingUpsell', 'hide');
    checkActiveSTPolicy()
  }, [])

  if (loading) {
    return (
      <LoadingSpinner text={'Getting your policy details...'}/>
    )
  }
  return null;
}

export default flow([
  withJob({
    work: (props: IAMTUpsellLandingProps) => {
      const promises = [];

      promises.push(props.actions.auth.reloadCustomer());
      promises.push(props.actions.auth.getCustomerRateableClaims());
      promises.push(props.actions.branding.loadChannel('admiral-b2c'));

      return Promise.all(promises);
    },
    LoadingComponent: () => <LoadingSpinner text={'Getting your policy details...'}/>,
    ErrorComponent: ({ error }) => {
      console.error(error);

      return (
        <div>
          {error.message}
        </div>
      );
    },
  }),
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
        quote: state.quote,
        branding: state.branding,
        mta: state.mta,
      };
    },
    (dispatch) => ({
      actions: {
        dispatch,
        auth: bindActionCreators({ ...authActions }, dispatch),
        header: bindActionCreators({ ...headerActions }, dispatch),
        push: bindActionCreators(push, dispatch),
        reset: bindActionCreators(reset, dispatch),
        destroy: bindActionCreators(destroy, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
        mta: bindActionCreators({ ...mtaActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
        paymentMethod: bindActionCreators({ ...paymentMethodActions }, dispatch),
      }
    }),
  ),
])(AMTUpsellLanding);
